import { css } from 'styled-components'
import { rem } from 'polished'

/**
 * Layout constants shared by the chat hotel room options widget.
 *
 * The widget renders inside a chat message, which is anywhere from a narrow
 * right-hand panel to a full-width desktop conversation, so every breakpoint
 * here is a *container* query against the widget shell rather than a viewport
 * media query.
 */

/** Widget width (px) at/above which the widget uses its roomier desktop gutters. */
export const WIDE_LAYOUT_BREAKPOINT = 560

/**
 * Room card width (px) at/above which the room summary puts its image beside
 * the room details, and a rate row puts pricing beside the rate details.
 * Below it both stack.
 */
export const ROOM_CARD_HORIZONTAL_BREAKPOINT = 560

/** Width (px) of the price + action column in the room card's horizontal layout. */
export const RATE_PRICE_COLUMN_WIDTH = 220

/** Packages shown before the "View N more packages" row hides the rest. */
export const DEFAULT_VISIBLE_RATE_COUNT = 3

/** Inclusions shown on a rate before the "View more inclusions" toggle hides the rest. */
export const DEFAULT_VISIBLE_INCLUSION_COUNT = 4

/**
 * Publishes the widget's horizontal gutter as a custom property so the padded
 * sections and the room selector carousel (which has to bleed *past* that
 * padding to scroll edge to edge) stay in step from a single source.
 */
export const chatRoomOptionsGutter = css`
  --chat-room-options-gutter: ${rem(16)};

  @container (min-width: ${rem(WIDE_LAYOUT_BREAKPOINT)}) {
    --chat-room-options-gutter: ${rem(24)};
  }
`
